
























import {
  defineComponent
} from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'ToggleCheck',
  model: {
    prop: 'value',
    event: 'update:modelValue'
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  emits: ['update:modelValue'],
  setup (props, { emit }) {
    const toggle = () => {
      emit('update:modelValue', !props.value)
    }
    return {
      toggle
    }
  }
})
